import React from 'react';
import { InfiniteLine } from 'js/components/common/InfiniteLine';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as hooks from '../../hooks';
import { LineItem } from './components/LineItem';
import { LINE_ANIMATION_SPEED } from '../../constants';

import style from './Line.scss';

export const Line = () => {
    const translate = useComponentTranslations();
    const topWinners = hooks.useTopWinners();

    return (
        <InfiniteLine
            classNames={{ ...style, wrapper: 'cms-top-winners-line' }}
            speed={LINE_ANIMATION_SPEED}
            stopIfNotEnoughContent={true}
            separator={translate('lineView.separator')}
        >
            {topWinners.map((topWinner, index) => (
                <LineItem
                    {...topWinner}
                    key={topWinner.id}
                    showSeparator={index !== topWinners.length - 1}
                />
            ))}
        </InfiniteLine>
    );
};
